import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t bg-gray-50 px-4 py-6 sm:px-6">
      <div className="mx-auto max-w-4xl text-center text-sm text-gray-500">
        <p>&copy; 2026 Echonour. All rights reserved.</p>
        <p className="mt-2">
          <Link to="/privacy" className="text-gray-500 underline hover:text-gray-700">Privacy Policy</Link>
          {" · "}
          <Link to="/terms" className="text-gray-500 underline hover:text-gray-700">Terms of Service</Link>
          {" · "}
          <Link to="/blog" className="text-gray-500 underline hover:text-gray-700">Blog</Link>
          {" · "}
          <a href="mailto:support@echonour.com" className="text-gray-500 underline hover:text-gray-700">Contact</a>
        </p>
      </div>
    </footer>
  );
}
